"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var checkConnection = function checkConnection() {
  return typeof AlgoSigner !== 'undefined';
};

var ConnectToAlgoSigner = function ConnectToAlgoSigner() {
  if (typeof window === 'undefined') {
    return {
      provider: AlgoSigner,
      connect: AlgoSigner.connect,
      check: checkConnection
    };
  }
};

var _default = ConnectToAlgoSigner;
exports.default = _default;